import {UserRoleProvider} from '@/context/UserRole/UserRoleProvider';
import {Template} from '@/pages/Template';
import {Outlet} from 'react-router-dom';

export const ProtectedRoutes = () => {
  return (
    <UserRoleProvider>
      <Template>
        <ProtectedRoutesContent />
      </Template>
    </UserRoleProvider>
  );
};

const ProtectedRoutesContent = () => {
  return <Outlet />;
};
